export class LoginRequest {
    public Password: string;
    public AccountNr: string;
    public RememberMe: boolean;
    public Guid: string;
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/login-request.ts